export default class PrintBehaviour  {

  constructor(options)
  {
  	if(!$(".b-header").length || $(".b-header").is(":visible"))
  	{  
      return;
    }
    console.log();

    this.PDF_EXPORT_PAGE_WIDTH = 1600;
    this.PDF_EXPORT_PAGE_HEIGHT = 2505;
    // this.PDF_EXPORT_PAGE_HEIGHT = 1370;

    this.options = $.extend({replaceBGImages:true,testing:true}, options);

    if(this.options.replaceBGImages)
    {
      this.replaceBGImages();
    }

    if(this.options.testing)
    {
      this.setVisiblePageLines();
    }

    window.setTimeout(() => this.setPageBreaks(), 2000);
    // this.setPageBreaks();
  }



  replaceBGImages()
  {
  	var $imageBGsToReplace = $(".-replace-with-img-for-print");
  	console.log("num bg images for print: " + $imageBGsToReplace.length);

  	$imageBGsToReplace.each(function()
  	{
  		var $currentBGImageElement = $(this);
  		$currentBGImageElement.css("position","relative");
  		$currentBGImageElement.css("overflow","hidden");
  		var imageHTMLTag = "<img src='"+$currentBGImageElement.attr("data-responsive-image")+"' class='bg-img-replacement' />";
  		$currentBGImageElement.removeAttr("data-responsive-image");
  		$currentBGImageElement.html(imageHTMLTag);
  	});

  }


  setVisiblePageLines()
  {
    // var heightOfWindow = 8000;
    // var INDICATION_EVERY_N_PIXELS = 10;
    // var loopNumTimes = heightOfWindow / INDICATION_EVERY_N_PIXELS;

    // for (var i = 0; i < loopNumTimes; i++)
    // {
    //   var loopPixel = i*INDICATION_EVERY_N_PIXELS;
    //   var element = "<h1 style='position:fixed;left:0;top:"+loopPixel+"px;'>"+loopPixel+"</h1>";
    //   $("body").append(element);
    // }
  }


  setPageBreaks()
  {
    console.log("setPageBreaks");
    $(".-print-page-break-after").removeClass("-print-page-break-after");
    $(".-print-page-break-before").removeClass("-print-page-break-before");

    var loopPages = 5;
    // var html = "";
    // for (var i = 0; i < loopPages; i++)
    // {  
    //   var topPosition = this.PDF_EXPORT_PAGE_HEIGHT * (i+1);
    //   html += "<div class='-print-page-indicator' style='top:"+topPosition+"px;'></div>"
    // }
    // $("body").append(html);

    var context =this;
    $("[data-print-break-type]").each(function()
    {
      var $this = $(this);
      var options = $this.data("print-break-options");
      switch($this.attr("data-print-break-type"))
      {
        case "child-on-different-page-then-container":
        {
          context.checkChildOnDifferentPageThenContainer.call(context,$this,options);
          break;
        }
      }
    });


    $(".-page-break-if-over-two-pages").each(function()
    {
      var $this = $(this);
      context.pageBreakIfElementOverTwoPages.call(context,$this);
    });

  }

  checkChildOnDifferentPageThenContainer(_$element,options)
  {
    //keys in options:
      //containerSelector
      //childSelector

    console.log(options);
    var $container = _$element.closest(options.containerSelector);
    var $childSelector = _$element.find(options.childSelector);

    var containerPage = this.getPageElementIsOn($container);
    var childPage = this.getPageElementIsOn($childSelector,true);

    if(containerPage === childPage)
    {
      //dont need to do anything
      return;
    }

    //break at the container
    $("body").html("Print Page Break Before");
    $container.addClass("-print-page-break-before");

  }

  pageBreakIfElementOverTwoPages(_$element)
  {
      var topOffsetY = _$element.offset().top;
      var bottomOffsetY = topOffsetY + _$element.height();


      var topOffsetPage = this.getPageYPixelIsOn(topOffsetY);
      var bottomOffsetPage = this.getPageYPixelIsOn(bottomOffsetY);

      if(topOffsetPage !== bottomOffsetPage)
      {
          _$element.addClass("-print-page-break-before");
      }
  }

  getPageElementIsOn(_$element,_fromBottomOfElement)
  {
    if(typeof _fromBottomOfElement === "undefined")
    {
      _fromBottomOfElement = false;
    }

    var elementOffsetY = _$element.offset().top;

    if(_fromBottomOfElement)
    {
      elementOffsetY += _$element.height();
    }

    return this.getPageYPixelIsOn(elementOffsetY);
  }

  getPageYPixelIsOn(_pixelYValue)
  {
    var numberOfPagesToCheck = 20;
    for (var i = 0; i < numberOfPagesToCheck; i++)
    {
      var pageNumberToCheck = i+1;
      var bottomOfPageYPosition = this.PDF_EXPORT_PAGE_HEIGHT * pageNumberToCheck;

      if(_pixelYValue < bottomOfPageYPosition)
      {
        return pageNumberToCheck;
      }
    }

    return -1;
  }


  //data-print-break-type="child-on-different-page-then-container" data-print-break-options='{"containerSelector":".m-accordion__item","childSelector":"ul > li:first"}'
}


// print-behaviour.js

// -replace-with-img-for-print


/** WEBPACK FOOTER **
 ** ./system/print-behaviour.js
 **/